import React, { useState, useEffect } from 'react'
import { Modal, Button, Steps, Popover } from 'antd'
import { orderService } from '../../orderService'
import moment from 'moment'
import { OperatorUserType } from '@/types/AppEnums'
import styled from '@emotion/styled'
const { Step } = Steps
const OrderLogs = ({ orderId, visible, setShowLogs }) => {
    const [logs, setLogs] = useState([])

    useEffect(() => {
        if (visible) {
            loadData()
        } else {
            setLogs([])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [visible])

    const loadData = () => {
        let data = {
            id: orderId,
            pageNum: 1,
            pageSize: 10000,
        }
        orderService.orderLogs(data).then((res) => {
            if (res.retData.records) {
                let { records } = res.retData
                records.sort((a, b) => {
                    return moment(b.recordTime).unix() - moment(a.recordTime).unix()
                })
                setLogs(records)
            }
        })
    }

    const onCancel = () => {
        setShowLogs(false)
    }

    const customDot = (dot, { status, index }) => (
        <Popover
            content={
                <span>
                    step {index} status: {status}
                </span>
            }
        >
            {dot}
        </Popover>
    )

    return (
        <Modal
            visible={visible}
            title="订单日志"
            width={800}
            onCancel={onCancel}
            footer={[
                <Button onClick={onCancel} key="back">
                    {' '}
                    取消
                </Button>,
            ]}
        >
            <LogSteps>
                <Steps className="logSteps" current={0} progressDot={customDot} direction="vertical">
                    {logs.map((item: any) => (
                        <Step
                            title={item.description}
                            subTitle={`${item.recordTime}`}
                            description={`操作人:${OperatorUserType[item.operatorUserType] || ''}--${item.operatorUserName || ''}`}
                            key={item.id}
                        />
                    ))}
                </Steps>
            </LogSteps>
        </Modal>
    )
}

const LogSteps = styled.div`
    .ant-steps-item-title {
        font-size: 20px;
    }
    .ant-steps-item-subtitle {
        font-size: 16px;
    }
    .ant-steps-item-description {
        font-size: 16px;
        color: #2e3aeb !important;
    }
`
export default OrderLogs
